import React from "react";
import PaymentStatusLayout from "./PaymentStatusLayout";

import SuccessSign from "assets/img/success-sign.png";

const PaymentSuccess = () => {
  return (
    <PaymentStatusLayout
      imageSrc={SuccessSign}
      altText="پرداخت موفق"
      alertColor="success"
      message={<p className="mb-2 p-0">پرداخت با موفقیت انجام شد!</p>}
      action={{
        text: "لیست سفارشات من",
        redirect: "/user-orders",
      }}
    />
  );
};

export { PaymentSuccess };
